// GraficoEstadosPlugin.js
import GraficoEstadosV1 from "./GraficoEstadosV1.vue";
import GraficoEstadosV1Properties from "./GraficoEstadosV1Properties.vue";

const GraficoEstadosPlugin = {
  install(Vue) {
    Vue.component("GraficoEstadosV1", GraficoEstadosV1);
    Vue.component("GraficoEstadosV1Properties", GraficoEstadosV1Properties);
  },
};

export default GraficoEstadosPlugin;
